var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "section",
        [
          _c(
            "PageHeader",
            {
              staticStyle: { "padding-top": "1rem" },
              attrs: { pageTitle: "Faturamento" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "0.5rem" } },
                [
                  _c("SelectMonth", {
                    model: {
                      value: _vm.search.month,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "month", $$v)
                      },
                      expression: "search.month"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectYear", {
                    model: {
                      value: _vm.search.year,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "year", $$v)
                      },
                      expression: "search.year"
                    }
                  }),
                  _vm._v(" "),
                  _vm.primaryFiltersHasSelected()
                    ? _c("SelectBillingStatus", {
                        model: {
                          value: _vm.search.billingStatus,
                          callback: function($$v) {
                            _vm.$set(_vm.search, "billingStatus", $$v)
                          },
                          expression: "search.billingStatus"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.billingList.length
                    ? _c("SelectPromoter", {
                        attrs: { traderList: _vm.traderList },
                        model: {
                          value: _vm.search.trader,
                          callback: function($$v) {
                            _vm.$set(_vm.search, "trader", $$v)
                          },
                          expression: "search.trader"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.billingList.length
                    ? _c("SelectAccountManager", {
                        model: {
                          value: _vm.search.accountManagerId,
                          callback: function($$v) {
                            _vm.$set(_vm.search, "accountManagerId", $$v)
                          },
                          expression: "search.accountManagerId"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.primaryFiltersHasSelected()
                    ? _c("GenericSearchInput", {
                        model: {
                          value: _vm.search.textSearch,
                          callback: function($$v) {
                            _vm.$set(_vm.search, "textSearch", $$v)
                          },
                          expression: "search.textSearch"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "VueJsonToCsv",
                    {
                      attrs: {
                        block: "",
                        "json-data": _vm.CSVBillingList,
                        separator: ";"
                      }
                    },
                    [
                      _c(
                        "BaseButtonComponent",
                        {
                          attrs: {
                            block: "",
                            variant: "primary-action",
                            disabled: !_vm.CSVBillingList.length
                          }
                        },
                        [_vm._v("\n            CSV\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.billingSummaryList.length
        ? _c("BillingStatusSummary", {
            attrs: { billingSummaryStatus: _vm.billingSummaryList }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 15,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "d-flex justify-content-between flex-column",
          staticStyle: { height: "100%" }
        },
        [
          !_vm.isLoading && _vm.billingList.length
            ? _c(
                "Table",
                { staticClass: "billing-table" },
                [
                  _c(
                    "TableHeader",
                    _vm._l(_vm.billingColumns, function(billingCol, index) {
                      return _c(
                        "TableHead",
                        { key: `${billingCol.name}_${index}` },
                        [
                          _c("ColumnHeader", {
                            attrs: {
                              sort: billingCol.sort,
                              somatory: billingCol.somatory,
                              columnName: billingCol.name,
                              columnKey: billingCol.key,
                              columnType: billingCol.columnType,
                              currentColumnFiltered: _vm.currentColumnFiltered,
                              sortDirection: _vm.sortDirection,
                              dataList: _vm.billingList
                            },
                            on: {
                              sortListByKey: function($event) {
                                return _vm.sortListByKey(billingCol.key)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.billingList, function(billing, index) {
                      return _c(
                        "TableRow",
                        { key: `${billing.installationNumber}_${index}` },
                        [
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.installationNumber) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: billing.name }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderInstallationStatusColumnValue", {
                                attrs: { value: billing.installationStatus }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderBillingStatusColumnValue", {
                                attrs: { value: billing.billingStatus }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.boletoVeins }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: billing.dueDate }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _c(
                              "span",
                              { style: _vm.setDelayedColor(billing.days) },
                              [_vm._v(_vm._s(billing.days))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.valueReceived }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.fine }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.paymentDiscount) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.compliance) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.totalCredit }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.consumerEconomy }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.percentagePowerPlant) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.repasseUsinaValue }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.grossIncomeValue }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.energyTariff) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderMoneyColumnValue", {
                                attrs: { value: billing.distributorInvoice }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.totalConsumption }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.distributionEnergy }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.compensatedEnergy }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.accumulatedBalance }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.lastAccumulatedBalance }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            {
                              style: _vm.setDeltaColorIfNegativeValue(
                                billing.deltaAccumulatedBalance
                              )
                            },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: {
                                  value: billing.deltaAccumulatedBalance
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("DownloadInvoiceButton", {
                                staticStyle: { padding: "0.1rem 0.8rem" },
                                attrs: {
                                  invoice: {
                                    nossoNumero: billing.nossoNumero,
                                    codigoSolicitacao:
                                      billing.codigoSolicitacao,
                                    name: billing.name,
                                    installationNumber:
                                      billing.installationNumber,
                                    dueDate: billing.dueDate,
                                    boletoVeins: billing.boletoVeins
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: billing.traderName || "" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: {
                                  name: billing.accountManagerName || ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.exemptEnergyKwh || 0 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.gdOneEnergyKwh || 0 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderKwhColumnValue", {
                                attrs: { value: billing.gdTwoEnergyKwh || 0 }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.tariffType) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.class) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  billing.subClass
                                    ? billing.subClass > 11
                                      ? `${billing.subClass.slice(0, 11)}...`
                                      : billing.subClass
                                    : ""
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.phase) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.energyProvider) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.zipCode) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.city) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.district) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.address) +
                                " " +
                                _vm._s(billing.number) +
                                "\n            " +
                                _vm._s(billing.complement) +
                                "\n            " +
                                _vm._s(billing.state) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.guaranteedDiscount) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.percentStandardDiscount) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.percentDiscountCoupon) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(billing.percentFidelityDiscount) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderNameColumnValue", {
                                attrs: { name: billing.site }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: { "social-number": billing.socialNumber }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.email) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderPhoneColumnValue", {
                                attrs: { "phone-number": billing.phone }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.salesInvoice) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: billing.dataInput }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.salesFiscal) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.linhaDigitavel) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: billing.sendBoletoDate }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            { staticStyle: { "text-align": "end" } },
                            [
                              _c("RenderDateColumnValue", {
                                attrs: { value: billing.paidDate }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              billing.billingStatus === "AWAITING_GEN_CALC" &&
                              _vm.userData.profile === _vm.PROFILE.admin
                                ? _c(
                                    "BaseButtonComponent",
                                    {
                                      staticStyle: { padding: "1px 12px" },
                                      attrs: { variant: "tertiary-action" },
                                      on: {
                                        click: () =>
                                          _vm.calcConsumptionItem(billing)
                                      }
                                    },
                                    [_vm._v("Gravar Consumo calculado")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              billing.billingStatus === "AWAITING_GEN_OV" &&
                              _vm.userData.profile === _vm.PROFILE.admin
                                ? _c(
                                    "BaseButtonComponent",
                                    {
                                      staticStyle: { padding: "1px 12px" },
                                      attrs: { variant: "primary-aciton" },
                                      on: {
                                        click: () => _vm.generateOVItem(billing)
                                      }
                                    },
                                    [_vm._v("Gerar OV")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              billing.billingStatus === "AWAITING_GEN_BOLETO" &&
                              _vm.userData.profile === _vm.PROFILE.admin
                                ? _c(
                                    "BaseButtonComponent",
                                    {
                                      attrs: {
                                        variant: "primary-action",
                                        block: ""
                                      },
                                      on: {
                                        click: () =>
                                          _vm.generateBoletoItem(billing)
                                      }
                                    },
                                    [_vm._v("Gerar Boleto")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ![
                                "AWAITING_GEN_CALC",
                                "AWAITING_GEN_OV",
                                "AWAITING_GEN_BOLETO",
                                "PAID"
                              ].includes(billing.billingStatus)
                                ? _c("MarkInvoiceToPaidButton", {
                                    attrs: { invoice: billing }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-overlay",
                                {
                                  staticClass: "d-inline-block",
                                  attrs: {
                                    show: _vm.busy,
                                    rounded: "",
                                    opacity: "0.6",
                                    "spinner-small": "",
                                    "spinner-variant": "primary"
                                  }
                                },
                                [
                                  (billing.billingStatus ===
                                    "WAITING_PAYMENT" ||
                                    billing.billingStatus === "PAID") &&
                                  _vm.userData.profile === _vm.PROFILE.admin
                                    ? _c(
                                        "BaseButtonComponent",
                                        {
                                          staticStyle: { padding: "1px 12px" },
                                          attrs: {
                                            disabled:
                                              billing.billingStatus === "PAID",
                                            variant: billing.emailSent
                                              ? "success-confirmattion"
                                              : "primary-action"
                                          },
                                          on: {
                                            click: () => _vm.sendEmail(billing)
                                          }
                                        },
                                        [_vm._v("Enviar Email")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.hasFidelity) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(billing.fidelityCounter) +
                                "\n          "
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : !_vm.isLoading
            ? _c("empty-list")
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }